import React from 'react';
import { LanguagesEnum } from '../../../../config/languages';
import ActionBlock from './components/datatable/actions';

const CONFIGURATION = {};

export const Translations = {
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  previous_use_header: {
    [LanguagesEnum.English]: 'Previous Use of Special Schemes',
    [LanguagesEnum.Greek]: 'Προηγούμενη χρήση ειδικών προγραμμάτων',
  },
  subtitle: {
    [LanguagesEnum.English]:
      'If you have already used this special scheme in another EU country, or used the special scheme for Telecommunications, Broadcasting or Electronic Services available to taxable people not established in the European Union, please list the VAT identification number(s) that you used',
    [LanguagesEnum.Greek]:
      'If you have already used this special scheme in another EU country, or used the special scheme for Telecommunications, Broadcasting or Electronic Services available to taxable people not established in the European Union, please list the VAT identification number(s) that you used',
  },
  issuing_country_label: {
    [LanguagesEnum.English]: 'Issuing Country',
    [LanguagesEnum.Greek]: 'Χώρα Έκδοσης',
  },
  scheme_type_label: {
    [LanguagesEnum.English]: 'Type',
    [LanguagesEnum.Greek]: 'Τύπος',
  },
  vat_number_label: {
    [LanguagesEnum.English]: 'VAT Number',
    [LanguagesEnum.Greek]: 'Αριθμός ΦΠΑ',
  },
  add_special_scheme: {
    [LanguagesEnum.English]: 'Add',
    [LanguagesEnum.Greek]: 'Προσθήκη',
  },
  add_header_button: {
    [LanguagesEnum.English]: 'Add Previous Use of Special Schemes',
    [LanguagesEnum.Greek]: 'Προσθήκη Previous Use of Special Schemes',
  },
};

export const TableColumns = (mode: 'VIEW' | 'EDIT') => {
  return [
    {
      label: '#',
      id: 'id',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'VAT Number',
      id: 'vat_id_num',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Country',
      id: 'country',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Scheme Type',
      id: 'scheme_type',
      render: (rowIndex: number, cellValue: any, columnIndex: number) => (
        <React.Fragment>{cellValue}</React.Fragment>
      ),
      inData: true,
    },
    {
      label: 'Actions',
      align: 'center',
      id: 'action',
      render: (
        rowIndex: number,
        cellValue: any,
        columnIndex: number,
        data: any
      ) => <ActionBlock rowIndex={rowIndex} mode={mode} />,
      inData: false,
    },
  ];
};

export default CONFIGURATION;
